<template>
    <Drawer
        width="500"
        placement="right"
        :closable="false"
        :visible="visible"
        v-bind="$attrs"
        v-on="$listeners"
        @close="close"
    >
        <div
            slot="title"
            class="flex items-center justify-between"
        >
            {{ $t('apiKeys') }}
            <span>
                <AntButton
                    class="mr-2"
                    :disabled="busy"
                    @click="add"
                >
                    {{ $t('add') }}
                </AntButton>
                <AntButton
                    type="primary"
                    @click="save"
                >
                    {{ $t('save') }}
                </AntButton>
            </span>
        </div>
        <ApiKeysCollapse
            :api-keys="apiKeys"
            @add="add"
        />
    </Drawer>
</template>

<script>
import ApiKeysCollapse from '@/components/customers/ApiKeysCollapse.vue';
import { Drawer, Button } from 'ant-design-vue';
import drawerMixin from '@/mixins/drawerMixin';
import debounce from 'lodash/debounce';
import { mapActions } from 'vuex';
const debounceLength = 800;
export default {
    name: 'ApiKeysDrawer',
    components: {
        Drawer,
        AntButton: Button,
        ApiKeysCollapse,
    },
    mixins: [drawerMixin],
    props: {
        apiKeys: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            busy: false,
        };
    },
    methods: {
        ...mapActions({
            generateApiKey: 'customers/generateApiKey',
            saveApiKeys: 'customers/saveApiKeys',
        }),
        add: debounce(function () {
            this.disableWhileDebouncing();
            this.generateApiKey();
        }, debounceLength, { leading: true, trailing: false }),
        disableWhileDebouncing() {
            setTimeout(() => {
                this.busy = false;
            }, debounceLength);

            this.busy = true;
        },
        save() {
            this.close();

            this.saveApiKeys()
                .then(this.apiKeysSavedSuccessNotification)
                .catch(this.apiKeysSavedFailedNotification);
        },
        apiKeysSavedSuccessNotification() {
            this.$notification.success({
                message: this.$t('entitySaved', {
                    entity: this.$t('apiKeys'),
                }),
            });
        },
        apiKeysSavedFailedNotification() {
            this.$notification.error({
                message: this.$t('oneOreMoreApiKeysFailedToUpdate'),
            });
        },
    },

};
</script>

<style>

</style>